const ROME_ZONE = 'Europe/Rome';
const ROME_PARTS = new Intl.DateTimeFormat('en-GB', {timeZone:ROME_ZONE, year:'numeric',month:'numeric',day:'numeric',hour:'numeric',minute:'numeric',second:'numeric',hourCycle:'h23'});

function localParts(epoch) {
  return Object.fromEntries(ROME_PARTS.formatToParts(new Date(epoch)).filter(part=>part.type!=='literal').map(part=>[part.type,Number(part.value)]));
}

function localEpoch(parts, hour) {
  const wall = Date.UTC(parts.year,parts.month-1,parts.day,hour);
  let epoch = wall;
  for (let i=0;i<3;i++) {
    const actual = localParts(epoch);
    const actualWall = Date.UTC(actual.year,actual.month-1,actual.day,actual.hour,actual.minute,actual.second);
    epoch += wall-actualWall;
  }
  return epoch;
}

export function shippingSchedule(now) {
  const local = localParts(now);
  const day = new Date(Date.UTC(local.year,local.month-1,local.day));
  const today = day.getUTCDay()!==0 && local.hour<17;
  if (!today) {
    do { day.setUTCDate(day.getUTCDate()+1); } while (day.getUTCDay()===0);
  }
  const target={year:day.getUTCFullYear(),month:day.getUTCMonth()+1,day:day.getUTCDate()};
  const cutoff=localEpoch(target,17);
  const start=localEpoch(target,0);
  return {today,cutoff,start,remaining:Math.max(0,Math.ceil((cutoff-now)/1000)),progress:Math.max(0,Math.min(1,(now-start)/(cutoff-start))),date:target};
}

if (typeof window!=='undefined' && !customElements.get('golden-shipping-clock')) {
  class GoldenShippingClock extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller=new AbortController();
      this.heading=this.querySelector('[data-shipping-title]');
      this.note=this.querySelector('[data-shipping-note]');
      this.time=this.querySelector('[data-shipping-countdown]');
      this.progress=this.querySelector('[data-shipping-progress]');
      this.format=new Intl.DateTimeFormat(this.dataset.locale||'it',{timeZone:ROME_ZONE,weekday:'long',day:'numeric',month:'long'});
      this.update();
      document.addEventListener('visibilitychange',()=>this.update(),{signal:this.controller.signal});
    }
    disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); }
    text(element,value) { if (element.textContent!==value) element.textContent=value; }
    update() {
      clearTimeout(this.timer);
      if (!this.isConnected) return;
      const state=shippingSchedule(Date.now());
      const date=this.format.format(new Date(state.cutoff));
      this.text(this.heading,state.today?this.dataset.today:this.dataset.next.replace('__date__',date));
      this.text(this.note,state.today?this.dataset.todayNote:this.dataset.nextNote.replace('__date__',date));
      const days=Math.floor(state.remaining/86400),hours=Math.floor(state.remaining%86400/3600),minutes=Math.floor(state.remaining%3600/60),seconds=state.remaining%60;
      const pieces=[];
      if (days) pieces.push(days+' '+this.dataset.days);
      pieces.push(hours+' '+this.dataset.hours,String(minutes).padStart(2,'0')+' '+this.dataset.minutes,String(seconds).padStart(2,'0')+' '+this.dataset.seconds);
      this.text(this.time,pieces.join(' '));
      this.time.dateTime=new Date(state.cutoff).toISOString();
      this.progress.value=state.progress;
      this.querySelector('[data-shipping-enhanced]').hidden=false;
      if (!document.hidden) this.timer=setTimeout(()=>this.update(),1000);
    }
  }
  customElements.define('golden-shipping-clock',GoldenShippingClock);
}
